import {
  Component, OnInit, HostListener, QueryList, AfterViewInit, Input, ViewEncapsulation, ViewChildren, ViewChild,
  SimpleChanges, OnChanges, ElementRef, ChangeDetectorRef
} from '@angular/core';
import {ProductsService} from "../../../../Common/Services/products.service";
import {IVariantGroupingType} from "../../../../Common/Interfaces/IVariantGroupingType";
import {environment} from "../../../../Common/environments/environment";
import {ICategoryBrowseFilterOptions} from "../../../../Common/Interfaces/ICategoryBrowseFilterOptions";
import {ActivatedRoute} from "@angular/router";
import * as _ from 'lodash';
import {GeneralHelpers} from "../../../../Common/helpers/general.helper";
import {TitleCasePipe} from "@angular/common";
import {Scene7Helper} from "../../../../Common/helpers/scene7.helper";
import VanillaScrollspy from '../../../../../../../src/js/Widgets/HanScrollSpy.js';
import * as smoothscroll from "smoothscroll-polyfill";
//declare var VanillaScrollspy: any;
@Component({
  selector: 'kws-section-navigation-electronic',
  templateUrl: './section-navigation-electronic.component.html',
  encapsulation: ViewEncapsulation.None
})
export class SectionNavigationElectronicComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() type: string;
  @Input() subtype: string;
  @Input() variantGroupingTypes: IVariantGroupingType[];
  @Input() variantGroupingTypesSingle: IVariantGroupingType;
  @Input() displayType: string;
  @Input() compareAllUrl: string;
  @Input() groupBy: string;
  @Input() cat: string;
  @Input() secondaryCat: string;
  @ViewChild('samePageNav') samePageNav: ElementRef;
  @ViewChild('dropButton') dropButton: ElementRef;
  @ViewChildren('tabParentDomElement') tabParentDomElement: QueryList<ElementRef>;
  staticSections: any = [];
  productListingUrl: string;
  variantGroupingsLength: number;
  flag: number = 0;
  activeTab: number = 0;
  isOpen: boolean = false;
  tabkey: string = "tab";
  slugifiedCategory: string;

  constructor(private route: ActivatedRoute, public cd: ChangeDetectorRef, private elementRef: ElementRef, public titlecase: TitleCasePipe, public productsService: ProductsService) {
    this.route = route;

  }

  ngOnInit() {
    this.slugifyCategory();
    this.productListingUrl = `${environment.serviceBaseUrl}/products/category/${this.slugifiedCategory}`;
    this.addStaticContentSections();
    smoothscroll.polyfill();

    let samePageNav = document.querySelector('#samePageNav');
    let scrollspy = new VanillaScrollspy(samePageNav);
    scrollspy.init();

    //check for empty compare url
    if(!this.compareAllUrl) {
      this.compareAllUrl = "#";
    }
  }

  ngAfterViewInit() {
    window.addEventListener('scroll', this.onScroll(this.flag));
    //subscribe to changes on tabParentDomElement so we get the full array length after static sections are added
    this.tabParentDomElement.changes.subscribe(() => {
      this.tabParentDomElement.toArray().map(x => x.nativeElement);

      let config = { attributes: true, childList: true, subtree: true };
      let observer = new MutationObserver(this.mutationObserverCallback);
      this.tabParentDomElement.forEach(function(tabItem, index){
        observer.observe(tabItem.nativeElement, config);
      });
    });
  }

  //CALLBACK WHEN THE MUTATION OBSERVER COMES BACK AS CHANGED
  mutationObserverCallback(mutationsList, observer) {
    for(let mutation of mutationsList) {
      if (mutation.type == 'attributes') {
        if(mutation.target.classList.contains('same-page-nav__item--selected')) {
          let index = GeneralHelpers.indexInParent(mutation.target);
          this.activeTab = index;
        }
      }
    }
  }

  addStaticContentSections() {
    let sections = document.querySelectorAll('.container-as-nav-item');

    Array.from(sections).forEach(section => {
      let label = section.getAttribute('data-placeholder-label');
      let uniqueLabel = GeneralHelpers.ensureUnique(GeneralHelpers.slugify(label));
      section.setAttribute('id', uniqueLabel);
      this.staticSections.push({title: label, slug: uniqueLabel});
    });
  }

  setTab(index, elem?) {
    this.activeTab = index;
    //if on mobile device
    if(document.documentElement.clientWidth < 992) {
      let buttonClicked = document.querySelector('.js-drop-button');
      buttonClicked.classList.toggle('same-page-nav__btn-drop--open');
      buttonClicked.textContent = elem.textContent;
      this.isOpen = !this.isOpen;
    }
  }

  toggleClass(e){
    e.preventDefault();
    this.isOpen = !this.isOpen;
  }

  checkScrollPositionIE11(scrollPos, stickyElement, stickyElementDesktop, filterBarContainer) {
    return function(){
      if(scrollPos >= filterBarContainer.offsetTop && scrollPos <= (filterBarContainer.offsetTop + filterBarContainer.offsetHeight)) {
        stickyElement.classList.add('fixedsticky-on');
        stickyElement.classList.remove('fixedsticky-off');
        stickyElementDesktop.classList.add('fixedsticky-on');
        stickyElementDesktop.classList.remove('fixedsticky-off');
      } else {
        stickyElement.classList.add('fixedsticky-off');
        stickyElement.classList.remove('fixedsticky-on');
        stickyElementDesktop.classList.add('fixedsticky-off');
        stickyElementDesktop.classList.remove('fixedsticky-on');
      }
    }
  }

  onScroll(flag) {
    let $this = this;
    return function(){
      let scrollPos = window.pageYOffset || document.documentElement.scrollTop;
      let navElementSelector = document.documentElement.clientWidth < 992 ? document.querySelector('.js-drop-button') : document.querySelector('.same-page-nav__item');
      let stickyElement = document.querySelector(".fixedsticky");
      let stickyElementDesktop = document.querySelector(".fixedsticky-desktop");
      let filterBarContainer = document.getElementById('filterbarelectronic');

      //SCROLL SPY WILL DISABLE THE FIRST ITEM IF IT GOES BACK TO THE TOP OF THE PAGE PREVENT THIS FROM HAPPENING
      if (scrollPos >= filterBarContainer.offsetTop) {
        if (flag === 0) {
          flag++;
        }

        let elems = document.querySelectorAll('.same-page-nav__item-image');
        var index = 0, length = elems.length;
        for (; index < length; index++) {
          elems[index].classList.add('hidden');
        }

    } else {
        flag = 0;
        $this.activeTab = 0;

        let elems = document.querySelectorAll('.same-page-nav__item-image');
        var index = 0, length = elems.length;
        for (; index < length; index++) {
          elems[index].classList.remove('hidden');
        }
      
        if(!document.getElementsByClassName('same-page-nav__item--selected').length) {
          document.querySelector('.same-page-nav__item').classList.add('same-page-nav__item--selected');
        }
      }

      //IE11 Fix
      if(navigator.userAgent.indexOf('MSIE')!==-1 || navigator.appVersion.indexOf('Trident/') > -1){
        $this.checkScrollPositionIE11(scrollPos, stickyElement, stickyElementDesktop, filterBarContainer);
      }

      if (document.documentElement.clientWidth < 992) {
        if (document.querySelector('.same-page-nav__item--selected')) {
          let link = document.querySelector('.same-page-nav__item--selected').children[0];
          if (navElementSelector.textContent !== link.textContent) {
            navElementSelector.textContent = link.textContent;
          }
        }
      }
    }
  }

  slideToView(element, event){
    event.preventDefault();
    let samePageNav = GeneralHelpers.getClosest(element,'.js-same-page-nav-nav');
    let targetId = element.getAttribute('href').split('#')[1];
    let target = document.getElementById(targetId);
    let top = target.offsetTop - ((document.documentElement.clientWidth < 992) ? 45 : 55);

    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });
  }

  getSectionNavThumb(image: string) {
    if(image){
      return Scene7Helper.imagePath(image, 'Kwikset', 'KWSFinishThumb');
    } else {
      image = 'locktype-unavailable';
      return Scene7Helper.imagePath(image, 'Kwikset', 'KWSFinishThumb');
    }
  }

  slugifyCategory() {
    this.slugifiedCategory = GeneralHelpers.ensureUnique(GeneralHelpers.slugify(this.cat));
  }

  ngOnChanges() {
    if (this.tabParentDomElement && this.tabParentDomElement.length) {
      let i = 0;
      this.tabParentDomElement.forEach(el => {
        if (el.nativeElement.classList.contains('same-page-nav__item--selected')) {
          this.activeTab = i;
          return;
        }
        i++;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/ts/Apps/CategoryBrowsing/src/app/section-navigation/section-navigation-electronic.component.ts